<!-- 上传文件组件 -->
<template>
    <div>
        <el-dialog title="文件上传" :visible.sync="diaFile" width="600px" :before-close="handleClose">
            <div class="fileBox">
                <el-form ref="form" label-width="80px">
                    <el-form-item label="编码">
                        <el-input size="mini" v-model="codingNum" placeholder="请输入编码"></el-input>
                    </el-form-item>
                </el-form>
                <div style="margin-left: 80px;padding: 10px 0;">
                    <p style="color: red; font-size: 18px;">请上传规格为21cm×29.7cm（210mm×297mm）的图片</p>
                </div>
                <div class="box" style="display: flex;margin-left: 80px;">
                    <el-upload class="upload-demo" ref="upload" :action="requesUrl + '/upload/fileupload'" :headers="token"
                        :on-preview="handlePreview" :on-remove="handleRemove" :file-list="fileList" :multiple="true"
                        :limit="20" :on-success="handleAvatarSuccess" :auto-upload="true" :on-exceed="handleExceed"
                        list-type="picture">
                        <!-- <el-button size="mini" type="primary" icon="el-icon-upload2">本地上传</el-button> -->

                        <el-button size="mini" type="success">本地上传</el-button>
                        <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                    </el-upload>
                    <el-button class="gpy" @click="openHighBeatMeter" size="mini" type="primary"
                        icon="el-icon-video-camera">高拍仪上传</el-button>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="diaFile = false">取 消</el-button>
                <el-button type="primary" @click="submitUpload">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="高拍仪拍照" destroy-on-close :visible.sync="dialogGPY" width="900px" style="overflow: hidden;height: 700px;"
            :before-close="handleClosegpy">
            <!-- <div style="margin-bottom:10px;">
                    <el-button id="instrumentAction" type="primary" size="mini">拍照</el-button>
                    <el-button id="rotateLeft" type="primary" size="mini">左转</el-button>
                    <el-button id="rotateRight" type="primary" size="mini">右转</el-button>
                    <el-button id="setdeskew" type="primary" size="mini">纠偏裁边</el-button>
                    <el-button id="showProperty" type="primary" size="mini">属性设置</el-button>
                    <select id="setScanSize">
                        <option value="">请选择图片类别</option>
                        <option value="原始尺寸">原始尺寸</option>
                        <option value="A4">A4</option>
                        <option value="卡片">卡片</option>
                    </select>
                </div>
                <div class="imgBox">
                    <div class="gpy_pic_box" style="width: 500px;
                height:500px">
                        <img src="" id="gpy_picture" style="width:100%;height:100%;" alt="">
                    </div>
                    <div class="showimg">
                        <div class="demo-image__preview gimage" v-for="(url, index) in imageList" :key="index">
                            <i @click="delFileImg(index)" class="el-icon-error err"></i>
                            <el-image 
                        style="width: 100px; height: 100px"
                        :src="url" 
                        :preview-src-list="[url]">
                    </el-image>
                            <cusImage style="width: 100px; height: 100px" :src="url" :preview-src-list="[url]">
                            </cusImage>
                        </div>
                    </div>

                </div> -->

            <!-- 高拍仪视频预览区 -->
            <div id="myactive">

                <!-- <span>主摄像头视频模式：</span> <select id="view1_mode" v-model="view1_mode_selected" @change="view1_mode_change(view1_mode_selected)"><option v-for="item in view1_mode_list" :key="item.key" :value="item.key">{{item.value}}</option></select> -->
                <span>图片质量:</span> <el-select id="view1_mode" v-model="altimeterData.quality">
                    <el-option label="默认质量" value="0"></el-option>
                    <el-option label="高质量" value="1"></el-option>
                    <el-option label="较高质量" value="2"></el-option>
                    <el-option label="中质量" value="3"></el-option>
                    <el-option label="较低质量" value="4"></el-option>
                    <el-option label="低质量" value="5"></el-option>
                </el-select>
                <!-- <span>色彩模式:</span><el-select size="mini" inline v-model="altimeterData.ColorMode">
                    <el-option label="彩色" value="0"></el-option>
                    <el-option label="灰色" value="1"></el-option>
                    <el-option label="黑白" value="2"></el-option>
                    <el-option label="白纸印章" value="3"></el-option>
                    <el-option label="去背景色(普通文件)" value="4"></el-option>
                    <el-option label="去背景色(身份证)" value="5"></el-option>
                </el-select> -->
                <span>色彩模式:</span><el-select size="mini" inline v-model="altimeterData.ColorMode">
                    <el-option label="白纸印章" value="3"></el-option>
                    <el-option label="彩色" value="0"></el-option>
                    <!-- <el-option label="灰色" value="1"></el-option> -->
                    <el-option label="黑白" value="2"></el-option>
                    <!-- <el-option label="去背景色(普通文件)" value="4"></el-option> -->
                    <!-- <el-option label="去背景色(身份证)" value="5"></el-option> -->
                </el-select>
                <!-- <br> -->

                <el-button style="margin-left:10px" @click="rotate(90)" type="primary" size="mini"
                    icon="el-icon-refresh-left" circle></el-button>
                <el-button style="margin-left:10px" @click="rotate(270)" type="primary" size="mini"
                    icon="el-icon-refresh-right" circle></el-button>
                <span style="margin-left:10px">图片剪切:</span>
                <el-switch style="margin-left:10px" @change="delBlackBoard" v-model="switchValue" active-color="#13ce66"
                    inactive-color="#ff4949">
                </el-switch>
                <span style="margin-left:10px">剪切值:</span>
                <el-input-number style="margin-left:10px" v-model="altimeterData.deskewval" size="mini"></el-input-number>
                <el-button style="margin-left:10px" @click="view1_scan" type="primary" size="mini">拍照</el-button>

                <!-- <el-button style="margin-left:10px"  @click="delBlackBoard(1)" type="primary" size="mini">开启图像纠偏</el-button>
                        <el-button style="margin-left:10px"  @click="delBlackBoard(0)" type="primary" size="mini">关闭图像纠偏</el-button> -->
            </div>
            <div class="view-warp">
                <div id="view">
                    <img id="view1" src="http://127.0.0.1:38088/video=stream&camidx=0" alt="主摄像头">
                </div>
                <!-- 缩略图 -->
                <div id="suoluetu">
                    <div v-for="(item, index) in img_base64List" :key="item" class="imgList">
                        <!-- <img :src="item"> -->
                        <el-image style="width: 100px; height: 100px;margin-bottom: 5px;" :src="item"
                            :preview-src-list="img_base64List">
                        </el-image>
                        <el-button type="danger" @click="delImgList(index)" size="mini">删除</el-button>
                    </div>

                </div>
            </div>


            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelGpy">取 消</el-button>
                <el-button type="primary" @click="congirmGpyFile">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="dialogImg" width="80%">
            <img v-if="imageUrl" :src="imageUrl" class="avatar" style="width:100%">
        </el-dialog>
    </div>
</template>
<script>
import { QWebChannel } from '@/assets/js/qwebchannel.js'
import axios from 'axios'
import {
    upFile,
} from "@/service/printApi.js";
var socket = ''
var imgList = []
export default {

    name: "upFile",
    data() {
        //这里存放数据
        return {
            token: { token: sessionStorage.getItem('token') },
            diaFile: false,
            fileList: [], //文件列表
            requesUrl: '',
            imgUrl: '',
            gpy: false,
            selectFileIds: [],
            view1_mode_list: [],
            view1_resolution_list: [],
            img_base64List: [],
            dialogGPY: false,
            imageList: imgList,
            codingNum: '',
            imageUrl: '',
            dialogImg: false,
            isChange: false,
            field: '',
            view1_mode_selected: '1',
            view1_resolution_selected: '',
            altimeterData: {
                "filepath": "base64",
                "rotate": "0",
                "cutpage": "0",
                "camidx": "0",
                "ColorMode": "0",
                "quality": "1",
                "deskew": "1",
                "deskewval": 50
            },
            switchValue: false

        }
    },
    // watch:{  
    //     fileList:{
    //         handler(newValue, oldValue){
    //             console.log(newValue,'newValue');
    //         }
    //     }
    // },
    // props: [settype],
    //方法集合
    methods: {
        delBlackBoard(e){
            let openFun = 0
            if(e== true){
                openFun = 1
            }
            console.log(this.switchValue,e)
            this.getStatus(openFun)
        },
        getStatus(e) {//拿状太，去黑边
            axios.post("http://127.0.0.1:38088/video=status").then((res) => {
                console.log(res)
                if (res.data.code == 0) {
                    setTimeout(() => {
                        let data = { "camidx": '0', "open": String(e) }
                        axios.post("http://127.0.0.1:38088/dvideo=cameradeskew", JSON.stringify(data)).then((res) => {
                        })
                    }, 500)
                }
            })
        },
        //删除列表图片
        delImgList(index) {
            this.img_base64List.splice(index, 1)
        },

        // 旋转
        rotate(angle) {
            let data = { "camidx": '0', "rotate": String(angle) }
            axios.post("http://127.0.0.1:38088/video=rotate", JSON.stringify(data)).then((res) => {
            })
        },

        // 切换主摄像头视频模式，重新加载主摄像头分辨率
        view1_mode_change(val) {
            let data = { "camidx": '0', "mode": val }
            axios.post("http://127.0.0.1:38088/device=getresolution", JSON.stringify(data)).then((res) => {
                let resolution_list = res.data.data.split("|");
                view1_resolution_selected = resolution_list[0]
                this.view1_resolution_list = []
                for (var i = 0; i < resolution_list.length; i++) {
                    this.view1_resolution_list.push(resolution_list[i])
                }
            })

        },

        // 主头拍照
        view1_scan() {
            axios.post("http://127.0.0.1:38088/video=grabimage", JSON.stringify(this.altimeterData)).then((res) => {
                console.log(res)
                this.add_image(res.data.photoBase64)
            })
        },
        add_image(img_base64) {
            console.log(img_base64)
            if (this.img_base64List.length >= 1) {
                // this.img_base64List = this.img_base64List.splice(1, 1)
                this.img_base64List.push("data:image/jpg;base64," + img_base64)
            } else {
                this.img_base64List.push("data:image/jpg;base64," + img_base64)
            }
        },
        cancelGpy() {
            this.dialogGPY = false
            this.gpy = false
        },
        // 高拍仪提交方法
        async congirmGpyFile() {
            var token = sessionStorage.getItem("token");
            this.img_base64List.forEach((key, i) => {
                var arr = key.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                var timestamp = (new Date()).valueOf()
                const formData = new FormData()
                var fileliu = new File([u8arr], timestamp + '.jpg', { type: mime })
                formData.append('file', fileliu)
                console.log(formData)
                upFile(formData, token).then((res) => {
                    if (res.status === 200) {
                        this.selectFileIds = []
                        this.selectFileIds.push(res.result[0])
                        // this.sendDataInfo.uploadVoList = this.selectFileIds
                        this.selectFileIds.forEach((i, index) => {
                            this.fileList.push({
                                ...i,
                                name: i.fileName,
                                url: this.imgUrl + "/" + i.fileUrl,

                            });
                        })
                        this.dialogGPY = false
                        // if (i == Number(this.img_base64List.length - 1)) {
                        //     this.subFileInfo()
                        // }
                    }
                });
                console.log(this.fileList, 'this.fileList');
            })
            this.dialogGPY = false
        },
        // 删除图片
        delFileImg(i) {
            imgList.splice(i, 1)
            this.imageList = imgList
        },
        // 打开高拍仪
        openHighBeatMeter() {
            console.log("打开高拍仪")
            this.imageList = []
            this.img_base64List = []
            // this.fileList=[]
            this.gpy = true
            this.dialogGPY = true
            // socket = new WebSocket("ws://127.0.0.1:12345");
            // socket.onclose = function () {
            //     console.error("web channel closed");
            // };
            // socket.onerror = function (error) {
            //     console.error("web channel error: " + error);
            // };
            // socket.onopen = function () {
            //     new QWebChannel(socket, function (channel) {
            //         // make dialog object accessible globally
            //         window.dialog = channel.objects.dialog;
            //         //网页关闭函数
            //         window.onbeforeunload = function () {
            //             dialog.get_actionType("closeSignal");
            //         }
            //         window.onunload = function () {
            //             dialog.get_actionType("closeSignal");
            //         }
            //         //接收图片流用来展示，多个，较小的base64数据
            //         dialog.send_priImgData.connect(function (message) {
            //             var element = document.getElementById("gpy_picture");
            //             element.src = "data:image/jpg;base64," + message;
            //         });

            //         //拍照按钮点击
            //         document.getElementById("instrumentAction").onclick = function () {
            //             dialog.photoBtnClicked("primaryDev_");
            //             dialog.get_actionType("savePhotoPriDev");
            //         };

            //         //左转
            //         document.getElementById("rotateLeft").onclick = function () {
            //             dialog.get_actionType("rotateLeft");
            //         };
            //         //右转
            //         document.getElementById("rotateRight").onclick = function () {
            //             dialog.get_actionType("rotateRight");
            //         };
            //         //属性设置
            //         document.getElementById("showProperty").onclick = function () {
            //             dialog.get_actionType("showProperty");
            //         };
            //         // 纠偏裁边
            //         document.getElementById("setdeskew").onclick = function () {
            //             dialog.get_actionType("setdeskew");
            //         };
            //         //设置尺寸列表点击，只有主头有设置尺寸
            //         document.getElementById("setScanSize").onchange = function () {
            //             var select = document.getElementById("setScanSize");
            //             if (select.value == "原始尺寸") {
            //                 dialog.get_actionType("setScanSize_ori");
            //             }
            //             if (select.value == "A4") {
            //                 dialog.get_actionType("setScanSize_A5");
            //             }
            //             if (select.value == "卡片") {
            //                 dialog.get_actionType("setScanSize_card");
            //             }
            //         };

            //         //接收拍照base64
            //         dialog.send_priPhotoData.connect(function (message) {
            //             var imageurl = "data:image/jpg;base64," + message;
            //             imgList.push(imageurl)
            //             this.imageList = imgList
            //             return false
            //         });
            //         //网页加载完成信号
            //         dialog.html_loaded("one");
            //     });
            // }
        },
        // 文件上传成功回调
        async handleAvatarSuccess(res, file, fileList) {
            if (res.status == 500) {
                this.fileList=fileList
                this.fileList.forEach((item,index)=>{
                    if (item.response.status==500) {
                        this.fileList.splice(index, 1)
                    }
                })
                return this.$message.error(res.message)
            }
            this.selectFileIds.push(res.result[0])
            this.fileList=fileList
            const img = new Image()
            img.src = window.URL.createObjectURL(file.raw)
            const { w, h } = await new Promise((resolve, reject) => {
                img.onload = () => {
                    const { width: w, height: h } = img;
                    resolve({ w, h })
                }
            })
            if (h / w < 210 / 297 && w / h < 210 / 297) {
                this.selectFileIds.forEach((item, index) => {
                    if (res.result[0].fileUrl == item.fileUrl) {
                        this.selectFileIds.splice(index, 1)
                    }
                })
                this.fileList.forEach((item, index) => {
                    if (res.result[0].fileUrl == item.fileUrl) {
                        this.fileList.splice(index, 1)
                    }
                })
                this.$message.warning("请上传正确规格的图片")
                return
            }

            // if (fileList.length == this.selectFileIds.length) {
            //     this.subFileInfo()
            // }
        },
        // 提交上传文件所有信息
        async subFileInfo() {
            console.log(this.$parent.busynessKey)
            if (this.isChange) {
                this.$parent.delFile(this.field, true)
            }
            let params = {
                busynessKey: this.$parent.busynessKey.toString(),
                busynessId: this.$parent.fileIds.toString(),
                fileType: this.$parent.upType,
                uploadVoList: this.fileList,
                codingNum: this.codingNum
            }
            let responseData = await this.$http.subFileInfo(params);
            if (responseData.status == 200) {
                this.$message({
                    message: '上传成功',
                    type: "success",
                });
                this.$parent.getFileListByIds()
                this.dialogGPY = false
                this.diaFile = false
                imgList = []
                this.imageList = imgList
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 文件上传服务器
        submitUpload() {
            // if(this.gpy){
            this.subFileInfo()
            // this.gpy=false
            // }else {
            this.$refs.upload.submit();
            // }
        },
        // 打开文件上传弹窗
        openFileDia(codingNum, field, row, type) {
            
            this.codingNum = ''
            if (codingNum) {
                this.isChange = true
                this.codingNum = codingNum
                this.field = field
            }
            if (type != 1) {
                this.fileList = []
                this.selectFileIds = []
            } else {
                this.fileList = []
                this.selectFileIds = []
                this.selectFileIds.push(row)
                this.selectFileIds.forEach((i, index) => {
                    this.fileList.push({
                        name: i.fileName,
                        url: this.imgUrl + "/" + i.fileUrl,
                    });
                })

            }
            imgList = []
            this.imageList = imgList
            this.diaFile = true
            console.log("123123231132123312312")
           
           
        },
        handleClose(done) {
            this.$confirm('确认取消文件上传？')
                .then(_ => {
                    this.diaFile = false
                    socket.close()
                    imgList = []
                    this.img_base64List = imgList
                    done();

                })
                .catch(_ => { });
        },
        handleClosegpy(done) {
            this.$confirm('确认取消文件上传？')
                .then(_ => {
                    this.dialogGPY = false
                    socket.close()
                    imgList = []
                    this.img_base64List = imgList
                    done();

                })
                .catch(_ => { });
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
            this.fileList=fileList
        },
        handlePreview(file) {
            console.log(file.url);
            this.imageUrl = file.url
            this.dialogImg = true
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 20 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },
        //获取图片存取的根路径
        imgurl() {
            // console.log(this.$store.getters.getConfig);
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },
        initVidio() {
            // 加载主摄像头视频模式
            let view1_mode_data1 = { "camidx": "0", "mode": "0" };
            let view1_mode_data2 = { "camidx": "0", "mode": "1" };
            axios.post("http://127.0.0.1:38088/device=getresolution", JSON.stringify(view1_mode_data2)).then((res) => {
                if (res.data.data.split("|").length > 1) {
                    let data = new Object()
                    data.key = '1'
                    data.value = 'MJPG'
                    this.view1_mode_list.push(data)
                }
            })
            // axios.post("http://127.0.0.1:38088/device=getresolution", JSON.stringify(view1_mode_data1)).then((res)=>{
            //   if(res.data.data.split("|").length > 1){
            //     let data = new Object()
            //     data.key = '0'
            //     data.value = 'YUY2'
            //     this.view1_mode_list.push(data)
            //   }
            // })
        },
    },
    //监听属性 类似于data概念
    computed: {},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.imgurl()
        this.initVidio()
        // this.getStatus()
        setTimeout(() => {
            this.switchValue = true
            this.getStatus(1)
        }, 100)

    },
    mounted() { }, //生命周期 - 挂载完成（可以访问DOM元素）
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() {
    }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
::v-deep.gpy {
    height: 34px;
    margin-left: 10px;
}



.imgBox {
    display: flex;
}

.gimage {
    margin-left: 20px;
    position: relative;
    width: 100px;
    height: 100px;
    margin-bottom: 20px;
}

.err {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 20px;
    z-index: 999;
    color: red;
    cursor: pointer;
}

.showimg {
    width: 360px;
    display: flex;
    flex-wrap: wrap;
    height: 100%;
}

.view-warp {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    height: 100%;
}

/* 全局 */
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    margin-top: 10px;
}

/* 视频预览 */
#view1,
#view2 {
    height: 300px;
    border: 1px solid #000;
    margin-right: 5px;
}

/* 缩略图 */
#suoluetu {
    width: 460px;
    display: flex;
    flex-wrap: wrap;
    height: 300px;
    overflow-y: auto;
}

#suoluetu .imgList {
    width: 100px;
    height: 140px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: column;
    margin: 5px;
}

/* 操作按钮 */
#myactive {
    /* border: 1px solid yellowgreen; */
    margin-top: 10px;
    padding: 10px 5px;
}

/* 操作日志 */
#mylog {
    border: 1px solid black;
    padding: 10px;
    margin-top: 10px;
    overflow: auto;

}
</style>
<style scoped>
.el-select {
    width: 150px !important;
}
</style>
